import Loader from 'react-loader-spinner';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { getTheme } from '../../theme';

const AppLoader = ({ style }) => {
  return (
    <Grid
      container
      direction='column'
      justify='center'
      alignItems='center'
      style={ { flexGrow: 1, height: '100%', ...style } }
    >
      <Grid item style={ { padding: '24px' } }>
        <Loader
          type='Grid'
          color={ getTheme().palette.secondary.dark }
          height={ 40 }
          width={ 40 }
        />
      </Grid>
    </Grid>
  );
};

export default AppLoader;
